import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

 

// User Role

export const getLeadSource = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-source",
    headers: getHeaders(),
  });
};

export const getLeadStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
  });
};
    
 

// lead

export const getLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateLead = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
 

export const getLeadDocument = (leadId) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead/" + leadId + "/document",
    headers: getHeaders(),
  });
};

export const addUserLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateUserLead = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};



export const getUserLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const userLeadAssign = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/assign",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getUserLeadStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-lead-status",
    headers: getHeaders(),
  });
};


export const getLeadType = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-type",
    headers: getHeaders(),
  });
};


//  Lead Status


export const getMasterLeadStatus = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/search-lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addMasterLeadStatus = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateMasterLeadStatus = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getLeadStatusApi = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/get-lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const DeleteLeadData = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/delete-lead-data",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getLeadSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getUserLeadSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/lead-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getLoanFileSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getLoanFileSummarySearch = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file/search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getUserLeadByRole = (leadId, role) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/lead/" + leadId + "/"+ role,
    headers: getHeaders(),
  });
};